import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable @next/next/no-img-element */
import { classNames } from '@yalendar/shared/ui-core';
import { useTranslation } from 'react-i18next';
export default function UltimateFeaturesItems(_ref) {
  var features = _ref.features;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx("div", {
    className: "relative pb-16 overflow-hidden",
    children: /*#__PURE__*/_jsx("div", {
      className: "",
      children: features.map(function (feature, index) {
        return /*#__PURE__*/_jsxs("div", {
          className: "mt-16 lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
          children: [/*#__PURE__*/_jsx("div", {
            className: "max-w-xl px-4 mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0",
            children: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx("span", {
                  className: "flex items-center justify-center w-12 h-12 bg-indigo-600 rounded-md",
                  children: feature.icon
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: "mt-6",
                children: [/*#__PURE__*/_jsx("h2", {
                  className: "text-3xl font-extrabold tracking-tight text-gray-900",
                  children: t(feature.name)
                }), /*#__PURE__*/_jsx("p", {
                  className: "mt-4 text-lg text-gray-500",
                  children: t(feature.description)
                })]
              })]
            })
          }), /*#__PURE__*/_jsx("div", {
            className: classNames(feature.left ? 'lg:col-start-1' : '', 'mt-12 sm:mt-16 lg:mt-0'),
            children: /*#__PURE__*/_jsx("div", {
              className: "pl-4 -mr-48 sm:pl-6 lg:px-0 lg:m-0 lg:relative lg:h-full",
              children: feature.image
            })
          })]
        }, index);
      })
    })
  });
}